import React from 'react';
import { FormField, SearchField } from '@/components/custom/erp';
import { ngoaiTeSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { NgoaiTe } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface GeneralTabProps {
  mode: FormMode;
  ngoaiTe: NgoaiTe | null;
  setNgoaiTe: (ngoaiTe: NgoaiTe) => void;
}

const GeneralTab = ({ mode, ngoaiTe, setNgoaiTe }: GeneralTabProps) => {
  const isViewMode = mode === 'view';

  return (
    <div className='h-64 max-h-[calc(100vh-250px)] overflow-y-auto'>
      <div className='space-y-2 p-4' style={{ width: '800px', minWidth: '800px' }}>
        <div className='flex flex-col space-y-3'>
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mt-2 sm:mb-0 sm:w-32 sm:min-w-32'>Ngoại tệ</Label>
            <SearchField<NgoaiTe>
              name='ma_nt'
              displayRelatedField={'ten_nt'}
              columnDisplay={'ma_nt'}
              searchEndpoint={`/${QUERY_KEYS.NGOAI_TE}`}
              searchColumns={ngoaiTeSearchColumns}
              dialogTitle='Danh mục ngoại tệ'
              value={ngoaiTe?.ma_nt || ''}
              onRowSelection={setNgoaiTe}
              disabled={isViewMode}
              className='w-100'
            />
          </div>
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mt-2 sm:mb-0 sm:w-32 sm:min-w-32'>Giá bán</Label>
            <FormField name='gia_nt2' type='number' disabled={isViewMode} />

            <div className='ml-4 whitespace-nowrap'>
              <FormField
                name='thue_yn'
                type='checkbox'
                label='Giá đã bao gồm thuế (Áp dụng cho tất cả giá của sản phẩm đang chọn)'
                disabled={isViewMode}
              />
            </div>
          </div>
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label htmlFor='status' className='mt-2 sm:mb-0 sm:w-32 sm:min-w-32'>
              Trạng thái
            </Label>
            <FormField
              id='status'
              type='select'
              name='status'
              disabled={isViewMode}
              options={[
                { label: '1. Còn sử dụng', value: '1' },
                { label: '0. Không sử dụng', value: '0' }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
